import React from 'react';
import { Container } from '@cp/ds/src/components/container';
import { Button } from '@cp/ds/src/components/button';
import { StepFooter } from '../stepFooter';
import { ClientRegistrationStepProps } from './model';

export const StepEmpty = ({ onSubmit }: ClientRegistrationStepProps) => {
  return (
    <Container>
      <StepFooter>
        <Button onClick={() => onSubmit({})}>Далее</Button>
      </StepFooter>
    </Container>
  );
};
